export default __webpack_public_path__ + "static/media/Subtraction 2.20ffc3f2.svg";